export default __webpack_public_path__ + "static/media/review-add.71e982a8.svg";